import { ReplaySubject } from 'rxjs';

import { AudioPacket } from './types';

const REPLAY_BUFFER_DURATION = 1000 * 60 * 2;
export const createNewAudioPacketSubject = () =>
  new ReplaySubject<AudioPacket>(undefined, REPLAY_BUFFER_DURATION);
